import styled from 'styled-components';
export var StyledVerticalCaretSvg = styled.svg.withConfig({
  componentId: "sc-tiema0-0"
})(["transform-origin:center;transition:transform ease-in 0.2s;"]);